export const NAME = 'newAdmin';
export const LEVEL_ONE = 'newAdminReducer';
